import { Cancel } from "@mui/icons-material";
import CropIcon from "@mui/icons-material/Crop";
import "./cropimagefile.scss";
import {
  Box,
  Button,
  Slider,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import Cropper from "react-easy-crop";
import "./cropimagefile.scss";
import getCroppedImg from "./Crop";
import { v4 as uuidv4 } from "uuid";
import imageCompression from "browser-image-compression";
import moment from "moment";
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import { storage } from "../../firebase";

export default function CropImageFile({
  setProgress,
  setStatusProgress,
  photoURL,
  openCrop,
  setOpenCrop,
  setPhotoURL,
  setImageFile,
  setUploadHook,
  srcFromBackend,
}) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [loading, setLoading] = useState(false);

  const newDate = moment(new Date()).format("MMdYYYY");

  // let driverLicenseImageFromLocal = localStorage.getItem("driverLicenseImageFromLocal");
  // console.log("driverLicenseImageFromLocal::", driverLicenseImageFromLocal);

  const cropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
    // console.log("croppedArea", croppedArea)
  };

  const cropImage = async () => {
    setLoading(true);
    try {
      const { file, url } = await getCroppedImg(
        photoURL,
        croppedAreaPixels,
        rotation
      );

      setTimeout(() => {
        setPhotoURL(url);
        setImageFile(file);
        setOpenCrop(false);
        //upload

        setStatusProgress(true);
        setProgress(10);

        uploadImage(file);
        deleteImage();
        setLoading(false);
        // setStatusProgress(true);
        // setProgress(10)
      }, 200);
    } catch (error) {
      console.log(error);
    }
  };

  //compress image in customer
  const uploadImage = async (file) => {
    if (!file) return;

    const options = {
      maxSizeMB: 0.3,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    const compressedFile = await imageCompression(file, options);
    let newName = `${uuidv4()}${newDate}${file.name.split(".").pop()}`;
    var newFile = new File([compressedFile], `${newName}.png`, {
      type: "image/png",
    });

    // to firbase
    const storageRef = ref(storage, `images/${newFile.name}`);
    const uploadTask = uploadBytesResumable(storageRef, compressedFile);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // console.log("progress::", progress)
      },
      (err) => console.log(err),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          // console.log("url::", url);
          setUploadHook(url);
          //Set in local storage for delete when upload again defore create staff
          window.localStorage.setItem("driverLicenseImageFromLocal", url);
        });
      }
    );
  };

  const deleteImage = () => {
    // const deleteRef = ref(storage, `event_backdrop/${urlFromBackend}`);
    if (srcFromBackend) {
      const deleteRef = ref(storage, srcFromBackend);
      deleteObject(deleteRef)
        .then(() => {
          console.log("delete this image successfully!");
        })
        .catch((err) => {
          console.log("can not delete this image!", err);
        });
    }
    // if (driverLicenseImageFromLocal) {
    //   const deleteImageCrop = ref(storage, driverLicenseImageFromLocal);
    //   deleteObject(deleteImageCrop)
    //     .then(() => {
    //       localStorage.removeItem("driverLicenseImageFromLocal");
    //       console.log("delete this draft image successfully!");
    //     })
    //     .catch((err) => {
    //       console.log("can not delete this draft image!", err);
    //     });
    // }
  };

  return (
    <Dialog open={openCrop} fullWidth maxWidth="sm" className="crop-container">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">Crop Image</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton
            onClick={() => {
              setOpenCrop(false);
              setImageFile("");
            }}
          >
            <CloseIcon className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers className="dialog-driverlicense">
        <Box className="crop-container">
          <Cropper
            image={photoURL}
            crop={crop}
            zoom={zoom}
            rotation={rotation}
            aspect={6/3.8}
            onZoomChange={setZoom}
            onRotationChange={setRotation}
            onCropChange={setCrop}
            onCropComplete={cropComplete}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ flexDirection: "column", mx: 1 }}>
        <Box sx={{ width: "100%", m: 1 }}>
          <Box>
            <Typography>Zoom: {zoomPercent(zoom)}</Typography>
            <Slider
              valueLabelDisplay="auto"
              valueLabelFormat={zoomPercent}
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e, zoom) => setZoom(zoom)}
            />
          </Box>
          <Box>
            <Typography>Rotation: {rotation + "°"}</Typography>
            <Slider
              valueLabelDisplay="auto"
              min={0}
              max={360}
              value={rotation}
              onChange={(e, rotation) => setRotation(rotation)}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            padding: "20px 0px",
          }}
        >
          <Button
            variant="outlined"
            startIcon={<Cancel />}
            onClick={() => {
              setOpenCrop(false);
              setImageFile("");
            }}
          >
            Cancel
          </Button>
          {loading ? (
            <Button variant="contained" startIcon={<CropIcon />}>
              Loading...
            </Button>
          ) : (
            <Button
              variant="contained"
              startIcon={<CropIcon />}
              onClick={() => cropImage()}
            >
              Crop
            </Button>
          )}
        </Box>
      </DialogActions>
    </Dialog>
  );
}

const zoomPercent = (value) => {
  return `${Math.round(value * 100)}%`;
};
